import { gql } from '@apollo/client'

export default gql`
  mutation DELETE_TAG_FROM_EPISODE($id: Int!) {
    delete_episode_x_tags(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`
